export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path !== from.path && process.client) {
    useState('headerSlidingMenu').value = false
  }
})
